import config from '@/configs'
import { Buffer } from 'buffer'
import moment from "moment"
import axios from 'axios';
import _ from 'lodash';
import { currency } from '@/commons/currency';
import { sendErrorNotice, pad } from '@/commons/utils';


export function request_header(token) {
  let header = {
    "Content-Type": "application/json",
    "accept": "application/json",
  };
  if(token) {
    header["Authorization"] = `Bearer ${token}`;
  }
  return header;
}

export function request_payload(param) {
  let query = '';
  let q_params = [];
  if(param && (param.pagination || param.qObject || param.filter || param.quickFilter)) {
    const page = param.pagination && param.pagination.page ? param.pagination.page : 1
    const rowsPerPage = param.pagination && param.pagination.itemsPerPage ? param.pagination.itemsPerPage : 1000000
    const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
    const descending = param.pagination ? param.pagination.sortDesc[0] : 1
    const qObject = param.qObject ? Buffer.from(JSON.stringify({ qObject: param.qObject })).toString("base64") : '';
    const filter = param.filter && param.filter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.filter })).toString("base64") : '';
    const quickFilter = param.quickFilter && param.quickFilter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.quickFilter })).toString("base64") : '';
    q_params.push(`filter=${encodeURIComponent(filter)}&qObject=${encodeURIComponent(qObject)}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}&q=${encodeURIComponent(quickFilter)}`)
  }
  
  if(param) {
    var fields = []
    Object.keys(param).forEach((key) => {
      if(!['pagination', 'qObject', 'filter', 'quickFilter'].includes(key)) {
        fields.push(`${key}=${param[key] || ''}`)
      }
    });
    q_params.push(`${fields.join('&')}`);
  }
  query = `?${q_params.join('&')}`;
  return query;
}

export function request_list(endpoint, cb, param, token) {
  const req = {
    headers: request_header(token)
  };
  const query = request_payload(param);
  axios.get(`${config.API}/api/${endpoint}/${query}`, req)
  .then((response) => setTimeout(() => cb(response.data), 100))
  .catch((error) => {
    if(error.response && error.response.status == 401) {
      window.getApp.$root.$emit("APP_AUTH_FAILED");
    }
  });
}

export function request_detail(endpoint, cb, id, token, param) {
  const header = {
    headers: request_header(token)
  };
  let query = '';
  if(param) {
    if(param.pagination) {
      const page = param.pagination ? param.pagination.page : 1
      const rowsPerPage = param.pagination ? param.pagination.itemsPerPage : 1000000
      const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
      const descending = param.pagination ? param.pagination.sortDesc[0] : 1
      query = `?page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}`;
      delete param.pagination;
    }
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = query == '' ? `?${fields.join('&')}` : `${query}&${fields.join('&')}`;
  }
  axios.get(`${config.API}/api/${endpoint}/${id}${query}`, header)
  .then((response) => setTimeout(() => cb(response.data), 100))
  .catch((error) => {
    if(error.response && error.response.status == 401) {
      window.getApp.$root.$emit("APP_AUTH_FAILED");
    }
  });
}

export function update_detail(endpoint, cb, param, pId, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  let path = pId == 0 ? `${config.API}/api/${endpoint}/` : `${config.API}/api/${endpoint}/${pId}`;
  
  axios.post(path, req, header)
  .then((response) => setTimeout(() => cb(response.data), 100))
  .catch((error) => {
    console.log(error);
    if(error.response && error.response.status == 401) {
      window.getApp.$root.$emit("APP_AUTH_FAILED");
    }
    else if(error.response.status == 406) {
      sendErrorNotice(error.response.data.reason);
    }
  });
}

export function remove_detail(endpoint, cb, id, token) {
  const header = {
    headers: request_header(token)
  };
  axios.delete(`${config.API}/api/${endpoint}/${id}`, header)
  .then((response) => setTimeout(() => cb(response.data), 100))
  .catch((error) => {
    if(error.response && error.response.status == 401) {
      window.getApp.$root.$emit("APP_AUTH_FAILED");
    }
  });
}

export function create_detail(endpoint, cb, param, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  delete req['ID'];
  delete req['isTrusted'];
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  
  axios.put(`${config.API}/api/${endpoint}/`, req, header)
  .then((response) => setTimeout(() => cb(response.data), 100))
  .catch((error) => {
    if(error.response && error.response.status == 401) {
      window.getApp.$root.$emit("APP_AUTH_FAILED");
    }
    else if(error.response.status == 406) {
      sendErrorNotice(error.response.data.reason);
    }
  });
}

export function upload_file(endpoint, cb, $http, param, token, func) {
  const header = {
    headers: request_header(token)
  };
  header.headers['Content-Type'] = 'multipart/form-data';
  func = func ? func : 'import'

  axios.post(`${config.API}/api/${endpoint}/${func}/`, param, header)
  .then((response) => setTimeout(() => cb(response.data), 100));
}

export function export_list(endpoint, cb, param, token, func) {
  const req = {
    headers: request_header(token),
    responseType: 'blob'
  };
  func = func ? func : 'export'
  const query = request_payload(param)

  axios.get(`${config.API}/api/${endpoint}/${func}/${query}`, req)
  .then((response) => setTimeout(() => cb(response.data), 100));
}

export function trade_type(value) {
  const cmtType = config.TRADE_TYPE.find(obj => obj.value === value);
  return cmtType ? cmtType.name : '';
}

export function print_export_receipt(item, packages, debt) {
  let html_packages = ''
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];
    html_packages = html_packages + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        <td class='body-text'>${p.product_code}</td>
                        <td class='body-text'>${p.product_name}</td>
                        <td class='body-text r-text'>${p.qty}</td>
                        <td class='body-text r-text'>${currency(p.unit_price,'',0)}</td>
                        <td class='body-text r-text'>${currency(p.discount,'',0)}</td>
                        <td class='body-text r-text'>${currency(p.price,'',0)}</td>
                        <td class='body-text r-text'>${currency(p.line_total,'',0)}</td>
                      </tr>`
  }

  const print_content = `<html>
  <head>
      <title></title>
      <style>
      .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 19px; font-weight: bold; text-align: center; } .sub-title { font-size: 16px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 16px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 16px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:210mm;font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text' colspan='2'>MEIMEI SHOP<br/>HOÁ ĐƠN BÁN HÀNG</td>
              </tr>	
              <tr>
                <td class='no-boder sub-title m-text'>Số HĐ: HD${pad(item.id,6)}</td>
                <td class='no-boder body-text m-text'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr>	
              <tr>        
                <td class='no-boder body-text' colspan='2'>Khách hàng: ${item.customer_first_name}</td>
              </tr>
              <tr>        
                <td class='no-boder body-text' colspan='2'>Điện thoại: ${item.customer_phone}</td>
              </tr>
              <tr>        
                <td class='no-boder body-text' colspan='2'>Địa chỉ: ${item.customer_address}</td>
              </tr>
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text'>STT</td>            
                  <td class='sub-title m-text'>Mã sản phẩm</td>            
                  <td class='sub-title m-text'>Tên hàng</td>
                  <td class='sub-title m-text'>SL</td>            
                  <td class='sub-title m-text'>Đơn giá</td>            
                  <td class='sub-title m-text'>Giảm giá</td>            
                  <td class='sub-title m-text'>Giá sau giảm</td>
                  <td class='sub-title m-text'>Thành tiền</td>
              </tr>
              ${html_packages}
              <tr>
                <td class='sub-title r-text' colspan='7'>Tổng số lượng:</td>
                <td class='sub-title r-text'>${currency(item.number_of_product,'',0)}</td>
              </tr> 
              <tr>
                <td class='sub-title r-text' colspan='7'>Tổng tiền hàng:</td>
                <td class='sub-title r-text'>${currency(item.total,'',0)}</td>
              </tr> 
              <tr>
                <td class='sub-title r-text' colspan='7'>Tổng giảm giá:</td>
                <td class='sub-title r-text'>${currency(item.discount,'',0)}</td>
              </tr> 
              <tr>
                <td class='sub-title r-text' colspan='7'>Tổng hoá đơn:</td>
                <td class='sub-title r-text'>${currency(item.amount,'',0)}</td>
              </tr>
              <tr>
                <td class='sub-title r-text' colspan='7'>Nợ cũ:</td>
                <td class='sub-title r-text'>${currency(debt.total_debt,'',0)}</td>
              </tr> 
              <tr>
                <td class='sub-title r-text' colspan='7'>Tổng cần thanh toán:</td>
                <td class='sub-title r-text'>${currency(debt.total_debt + item.amount,'',0)}</td>
              </tr> 
              <tr>
                  <td class='no-boder sub-title m-text' colspan='4'>Người kiểm phiếu<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='4'>Người lập phiếu<br/><i>(Ký, ghi rõ họ tên)</i></td>
              </tr> 
              </table>
            </div>
        </body>
  </html>`;
  return print_content;
}

export function print_export_return(item, packages) {
  let html_packages = ''
  for (let i = 0; i < packages.length; i++) {
    const p = packages[i];
    html_packages = html_packages + `<tr>
                        <td class='body-text m-text'>${i+1}</td>
                        <td class='body-text'>${p.product_code}</td>
                        <td class='body-text'>${p.product_name}</td>
                        <td class='body-text r-text'>${p.qty}</td>
                        <td class='body-text r-text'>${currency(p.unit_price,'',0)}</td>
                        <td class='body-text r-text'>${currency(p.discount,'',0)}</td>
                        <td class='body-text r-text'>${currency(p.price,'',0)}</td>
                        <td class='body-text r-text'>${currency(p.line_total,'',0)}</td>
                      </tr>`
  }

  const print_content = `<html>
  <head>
      <title></title>
      <style>
      .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 19px; font-weight: bold; text-align: center; } .sub-title { font-size: 16px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 16px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 16px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #4a4a4a; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; height: 30px; padding: 5px} @media print { @page { size: auto; margin: 20mm 8mm 8mm 20mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } } .no-boder {border: 0px !important;} .quantity {width: 30px;} .width-volumn {width: 50px;}
      </style>
  </head>
  
  <body style='width:210mm;font-family: Roboto,sans-serif;'>
      <div class='layout wrap'>
          <table>
              <tr>
                <td class='no-boder sub-title m-text' colspan='2'>MEIMEI SHOP<br/>HOÁ ĐƠN NHẬP HÀNG</td>
              </tr>	
              <tr>
                <td class='no-boder sub-title m-text'>Số HĐ: HD${pad(item.id,6)}</td>
                <td class='no-boder body-text m-text'><i>Ngày ${moment().date()} tháng ${moment().month()+1} năm ${moment().year()}</i></td>
              </tr>	
              <tr>        
                <td class='no-boder body-text' colspan='2'>Khách hàng: ${item.customer_first_name}</td>
              </tr>
              <tr>        
                <td class='no-boder body-text' colspan='2'>Điện thoại: ${item.customer_phone}</td>
              </tr>
              <tr>        
                <td class='no-boder body-text' colspan='2'>Địa chỉ: ${item.customer_address}</td>
              </tr>
            </table>
            <table>
              <tr>
                  <td class='sub-title m-text'>STT</td>            
                  <td class='sub-title m-text'>Mã sản phẩm</td>            
                  <td class='sub-title m-text'>Tên hàng</td>
                  <td class='sub-title m-text'>SL</td>            
                  <td class='sub-title m-text'>Đơn giá</td>            
                  <td class='sub-title m-text'>Giảm giá</td>            
                  <td class='sub-title m-text'>Giá sau giảm</td>
                  <td class='sub-title m-text'>Thành tiền</td>
              </tr>
              ${html_packages}
              <tr>
                <td class='sub-title r-text' colspan='7'>Tổng số lượng:</td>
                <td class='sub-title r-text'>${currency(item.number_of_product,'',0)}</td>
              </tr> 
              <tr>
                <td class='sub-title r-text' colspan='7'>Tổng tiền hàng:</td>
                <td class='sub-title r-text'>${currency(item.total,'',0)}</td>
              </tr> 
              <tr>
                <td class='sub-title r-text' colspan='7'>Tổng giảm giá:</td>
                <td class='sub-title r-text'>${currency(item.discount,'',0)}</td>
              </tr> 
              <tr>
                <td class='sub-title r-text' colspan='7'>Khách cần trả:</td>
                <td class='sub-title r-text'>${currency(item.amount,'',0)}</td>
              </tr> 
              <tr>
                  <td class='no-boder sub-title m-text' colspan='4'>Người kiểm phiếu<br/><i>(Ký, ghi rõ họ tên)</i></td>
                  <td class='no-boder sub-title m-text' colspan='4'>Người lập phiếu<br/><i>(Ký, ghi rõ họ tên)</i></td>
              </tr> 
              </table>
            </div>
        </body>
  </html>`;
  return print_content;
}